import { gql } from 'graphql-request'
import { z } from 'zod'

export const flightSchema = z.object({
  arrival: z.string(),
  departure: z.string(),
  destination: z.object({
    code: z.string(),
    cityName: z.string(),
  }),
  origin: z.object({
    code: z.string(),
    cityName: z.string(),
  }),
  duration: z.string(),
  segments: z.array(
    z.object({
      airline: z.object({
        name: z.string(),
        code: z.string(),
      }),
    })
  ),
})

export const flightFragment = (isSliceFlight = false) => gql`
  fragment FlightFragment on ${isSliceFlight ? 'SliceFlight' : 'Flight'} {
    arrival
    departure
    destination {
      code
      cityName
    }
    origin {
      code
      cityName
    }
    duration
    segments {
      airline {
        code
        name
      }
    }
  }
`

export type Flight = z.infer<typeof flightSchema>
